// extracted by mini-css-extract-plugin
module.exports = {"cardContentWidth":"800px","primaryColor":"#000","secondaryColor":"#c0c0c0"};